import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getIntegrationUsers = (params) => {
  const queryParams = getQueryParams(params);
  const url = `/api/integrationUsers${queryParams}`;
  return makeRequest(authFetch.get(url));
};

export const getIntegrationUserDetails = (id) => {
  const url = `/api/integrationUsers/${id}`;
  return makeRequest(authFetch.get(url));
};

export const deleteIntegrationUser = (id) => {
  const url = `/api/integrationUsers/${id}`;
  return makeRequest(authFetch.delete(url));
};

export const upsertIntegrationUser = (data) => {
  const url = '/api/integrationUsers';
  return makeRequest(authFetch.put(url, data));
};

export const restoreIntegrationUser = (id) => {
  const url = `/api/integrationUsers/${id}/restore`;
  return makeRequest(authFetch.patch(url));
};

export const getIntegrationUserTokens = (id) => {
  const url = `/api/integrationUsers/${id}/tokens`;
  return makeRequest(authFetch.get(url));
};

export const upsertIntegrationUserToken = (id, data) => {
  const url = `/api/integrationUsers/${id}/tokens`;
  return makeRequest(authFetch.put(url, data));
};

export const deleteIntegrationUserToken = (id, tokenId) => {
  const url = `/api/integrationUsers/${id}/tokens/${tokenId}`;
  return makeRequest(authFetch.delete(url));
};

export const regenerateIntegrationUserToken = (id, tokenId) => {
  const url = `/api/integrationUsers/${id}/tokens/${tokenId}`;
  return makeRequest(authFetch.patch(url));
};

export const getIntegrationUserAudits = (id, params) => {
  const queryParams = getQueryParams(params);
  const url = `/api/integrationUsers/${id}/audits?${queryParams}`;
  return makeRequest(authFetch.get(url));
};

export const getIntegrationUserAuditUsers = (id) => {
  const url = `/api/integrationUsers/${id}/audits/users`;
  return makeRequest(authFetch.get(url));
};

export const getIntegrationUserAuditProperties = (id) => {
  const url = `/api/integrationUsers/${id}/audits/properties`;
  return makeRequest(authFetch.get(url));
};
